import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import hljs from 'highlight.js/lib/core';
import bash from 'highlight.js/lib/languages/bash';
import json from 'highlight.js/lib/languages/json';

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('json', json);

@Component({
    selector: 'app-code-block',
    templateUrl: './code-block.component.html',
    styleUrls: ['./code-block.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CodeBlockComponent implements AfterViewInit {
    @Input() code: string;
    @Input() language: 'bash' | 'json' = 'json';
    @Input() title?: string;

    @ViewChild('codeEl') codeEl: ElementRef;

    copied = false;

    ngAfterViewInit(): void {
        hljs.highlightElement(this.codeEl.nativeElement);
    }

    copy(): void {
        const clipboard = (navigator as any).clipboard;
        if (!clipboard) {
            return;
        }

        clipboard.writeText(this.code || '')
            .then(() => {
                this.copied = true;
                setTimeout(() => this.copied = false, 2000);
            })
            .catch(() => { });
    }
}
